import { headers as headersCE } from "./headers";
import { headersSelo } from "./headersSelo";
import { headersParceiro } from "./headersParceiro";
import { headersGov } from "./headersGov";
import { headersATS } from "./headersATS";

import { filtros } from "./filtros";
import { categorias } from "./categorias";
import { atualUfDefinition } from "@/helpers/utils";

function getTitle() {
  if (atualUfDefinition.isParceiro) {
    return {
      1: "Execução por Atividades",
      3: "Relatórios por Iniciativas",
      4: "Encontros por Iniciativas",
      5: "Situação das visitas por parceiro",
      6: "Situação das atividades por parceiro",
      7: "Diagnósticos Pendentes por pilar e parceiro",
      9: "O que falta evidenciar por parceiro e pilar",
      15: "Execução por atividades com data de início e fim",
      16: "Parceiros e pilar por Status do Relacionamento",
      17: "Quantidade de Mensurações realizadas por regional e parceiro",
      18: "Parceiros por região e pilar com a quantidade de mensurações",
      20: "Lista de critérios ativos",
      21: "Consolidado de critérios respondidos SIM por pilar, parceiro e Unidade Regional",
      22: "Analítico de critérios com respectivas respostas dos parceiro e regiões selecionadas",
      23: "Plano de ação analítico - atualizado por parceiro, pilar e região",
      24: "Pilar por parceiro",
      25: "Pilar por parceiro - desagrupado",
      27: "Critérios rejeitados por parceiros",
      28: "Parceiros com respectivos selos atribuídos",
      34: "Analítico de Pontos por Pilar",
      35: "Quantitativo de parceiros com e sem atuação por região",
      37: "Parceiros / Territórios com status da atuação e responsável",
      37: "Situação das soluções nos parceiros",
      50: "O que falta evidenciar por parceiros e pilar (detalhado)",
    };
  }
  if (atualUfDefinition.isSala) {
    return {
      1: "Execução por Atividades",
      3: "Relatórios por Iniciativas",
      4: "Encontros por Iniciativas",
      5: "Situação das visitas por sala",
      6: "Situação das atividades por sala",
      7: "Diagnósticos Pendentes por pilar e sala",
      9: "O que falta evidenciar por sala e pilar",
      15: "Execução por atividades com data de início e fim",
      16: "Salas e pilar por Status do Relacionamento",
      17: "Quantidade de Mensurações realizadas por regional e sala",
      18: "Salas por região e pilar com a quantidade de mensurações",
      20: "Lista de critérios ativos",
      21: "Consolidado de critérios respondidos SIM por pilar, sala e Unidade Regional",
      22: "Analítico de critérios com respectivas respostas dos sala e regiões selecionadas",
      23: "Plano de ação critérios - atualizado por sala, pilar e região",
      24: "Pilar por sala",
      25: "Pilar por sala - desagrupado",
      27: "Critérios rejeitados por sala",
      28: "Salas com respectivos selos atribuídos",
      34: "Analítico de Pontos por Pilar",
      35: "Quantitativo de salas com e sem atuação por região",
      37: "Salas / Territórios com status da atuação e responsável",
      41: "Situação das iniciativas nas salas",
      42: "Prateleira de iniciativas",
      50: "O que falta evidenciar por sala e pilar (detalhado)",
    };
  }
  if (atualUfDefinition.isAT) {
    return {
      1: "Execução por Atividades",
      3: "Relatórios por Iniciativas",
      4: "Encontros por Iniciativas",
      5: "Situação das visitas por sala",
      6: "Situação das atividades por sala",
      15: "Execução por atividades com data de início e fim",
      41: "Agendas já realizadas por Status",
      42: "Prateleira de iniciativas",
    };
  }
  if (atualUfDefinition.isGov) {
    return {
      1: "Execução por Atividades",
      3: "Relatórios por Fases",
      4: "Encontros por Fases",
      5: "Fases das visitas por projeto",
      6: "Fases das atividades por projeto",
      7: "Diagnósticos Pendentes por eixo e projeto",
      15: "Execução por atividades com data de início e fim",
      16: "Projeto e eixos por Status do Relacionamento",
      17: "Quantidade de Mensurações realizadas por regional e projeto",
      18: "Projetos por região e eixos com a quantidade de mensurações",
      21: "Consolidado de indicadores respondidos SIM por eixo, projeto e Unidade Regional",
      22: "Analítico de indicadores com respectivas respostas dos projetos e regiões selecionadas",
      23: "Plano de ação analítico - atualizado por projeto, eixo e região",
      24: "Eixos por projeto",
      25: "Eixos por projeto - desagrupado",
      27: "Evidências rejeitadas por projeto",
      35: "Quantitativo de projetos com e sem atuação por região",
      37: "Projetos / Territórios com status da atuação e responsável",
      41: "Fases das soluções nos projetos",
      42: "Prateleira de fases",
      50: "O que falta evidenciar por projeto e eixo (detalhado)",
    };
  }

  return {};
}

function headers() {
  if (atualUfDefinition.isParceiro) {
    return headersParceiro;
  }
  if (atualUfDefinition.isSala) {
    return headersSelo;
  }
  if (atualUfDefinition.isAT) {
    return headersATS;
  }
  if (atualUfDefinition.isGov) {
    return headersGov;
  }
  return headersCE;
}

export const relatorios = [
  {
    title: getTitle()[1] || "Execução por Tarefas",
    rotaApi: "get-execucao-por-tarefas",
    header: headers().execucao_por_tarefas,
    category: categorias().execucao,
    id: 1,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
    ],
  },
  {
    title: getTitle()[2] || "Execução por horas",
    rotaApi: "get-execucao",
    header: headers().execucao,
    category: categorias().execucao,
    id: 2,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
    ],
  },
  {
    title: getTitle()[3] || "Relatórios por Solução",
    rotaApi: "get-relatorios-por-solucao",
    header: headers().relatorio_por_solucao,

    category: categorias().execucao,
    id: 3,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[4] || "Encontros por Solução",
    rotaApi: "get-encontros-por-solucao",
    header: headers().encontros_por_solucao,

    category: categorias().execucao,
    id: 4,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[5] || "Situação das visitas por município",
    rotaApi: "get-situacao-visitas",
    header: headers().situacaoVisitas,
    category: categorias().indicador,
    id: 5,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[6] || "Situação das tarefas por município",
    rotaApi: "get-situacao-tarefas",
    header: headers().situacaoTarefa,
    category: categorias().indicador,
    id: 6,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[7] || "Diagnósticos Pendentes por eixo e município",
    rotaApi: "get-municipios-sem-diagnostico",
    header: headers().diagnostico,
    category: categorias().indicador,
    id: 7,
    filters: [filtros.statusRelacionamento],
  },
  {
    title: getTitle()[8] || "Diagnósticos Finalizados",
    rotaApi: "get-diagnosticos-finalizados",
    header: headers().diagnosticoFinalizado,

    category: categorias().indicador,
    id: 8,
    filters: [filtros.statusRelacionamento],
  },

  {
    title: getTitle()[9] || "O que falta evidenciar por município e eixo",
    rotaApi: "get-falta-evidenciar",
    header: headers().evidencias,
    eadersParceiro: headersParceiro.evidencias,

    category: categorias().indicador,
    id: 9,
    filters: [filtros.statusRelacionamento, filtros.regional],
  },
  {
    title: getTitle()[10] || "Situação das evidências enviadas",
    rotaApi: "get-aprovacao-rejeicao",
    header: headers().rejeicao,
    dersParceiro: headersParceiro.rejeicao,

    category: categorias().indicador,
    id: 10,
    filters: [filtros.statusRelacionamento, filtros.regional],
  },
  // {
  //     title: getTitle()[11] || "Execução das horas",
  //     rotaApi: "get-execucao-por-horas",
  //     header: headers().execucao_hora,
  //     category: categorias().execucao,
  //     id: 11,
  //     filters: [
  //         filtros.municipio,
  //         filtros.responsavel,
  //         filtros.solucao,
  //         filtros.grupoSolucao,
  //         filtros.grupoUsuario,
  //         filtros.statusRelacionamento,
  //         filtros.dataInicial,
  //         filtros.dataFim,
  //     ],
  // },
  {
    title: getTitle()[12] || "Situação das medalhas",
    rotaApi: "get-execucao-por-situacao-medalha",
    header: headers().situacao_medalha,
    category: categorias().indicador,
    id: 12,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[13] || "Situação geral de pontos e medalhas",
    rotaApi: "get-execucao-por-situacao-pontos-medalha-por-tema",
    header: headers().situacao_medalha_pontos_tema,
    category: categorias().indicador,
    id: 13,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[14] || "Radar",
    rotaApi: "",
    component: "Radar",
    id: 14,
    category: categorias().execucao,
  },
  {
    title: getTitle()[15] || "Execução por tarefas com data de início e fim",
    rotaApi: "get-execucao-por-tarefas-inicio-fim",
    header: headers().execucao_tarefas_inicio_fim,
    category: categorias().execucao,
    id: 15,
    filters: [
      filtros.municipio,
      filtros.responsavel,
      filtros.solucao,
      filtros.grupoSolucao,
      filtros.grupoUsuario,
      filtros.statusRelacionamento,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[16] || "Município e eixos por Status do Relacionamento",
    rotaApi: "get-status-relacionamento",
    header: headers().municipio_eixo_status_relacionamento,
    category: categorias().indicador,
    id: 16,
    filters: [
      filtros.uf,
      filtros.regional,
      filtros.status,
      filtros.eixo,
      filtros.statusRelacionamento,
    ],
  },
  {
    title:
      getTitle()[17] ||
      "Quantidade de Mensurações realizadas por regional e município",
    rotaApi: "get-mensuracao",
    header: headers().municipio_quantidade_mensuracoes_regional_municipio,
    category: categorias().indicador,
    id: 17,
    filters: [
      filtros.uf,
      filtros.regional,
      filtros.status,
      filtros.eixo,
      filtros.statusRelacionamento,
    ],
  },
  {
    title:
      getTitle()[18] ||
      "Municípios por região e eixos com a quantidade de mensurações",
    rotaApi: "get-municipio-regiao",
    header: headers().municipio_quantidade_mensuracoes,
    category: categorias().indicador,
    id: 18,
    filters: [
      filtros.uf,
      filtros.regional,
      filtros.status,
      filtros.eixo,
      filtros.statusRelacionamento,
    ],
  },
  {
    title: getTitle()[19] || "Alerta para T0 pendente",
    rotaApi: "get-alerta-to",
    header: headers().to_pendentes,
    category: categorias().indicador,
    id: 19,
    filters: [
      filtros.uf,
      filtros.regional,
      filtros.status,
      filtros.tema,
      filtros.statusRelacionamento,
    ],
  },
  {
    title: getTitle()[20] || "Lista de indicadores ativos",
    rotaApi: "get-indicadores-ativos",
    header: headers().indicadores_ativos,
    category: categorias().indicador,
    id: 20,
    filters: [filtros.eixo],
  },
  {
    title:
      getTitle()[21] ||
      "Consolidado de indicadores respondidos SIM por eixo, município e Unidade Regional",
    rotaApi: "get-indicadores-consolidado",
    header: headers().consolidado_indicadores_sim,
    category: categorias().indicador,
    id: 21,
    filters: [filtros.uf, filtros.regional, filtros.eixo],
  },
  {
    title:
      getTitle()[22] ||
      "Analítico de indicadores com respectivas respostas dos municípios e regiões selecionadas",
    rotaApi: "get-indicadores-analiticos",
    header: headers().analitico_indicadores,
    category: categorias().indicador,
    defaultFilters: {
      municipioId: [0],
    },
    id: 22,
    filters: [
      filtros.uf,
      filtros.regional,
      filtros.eixo,
      filtros.projeto,
      filtros.regional,
      filtros.dataInicial,
      filtros.dataFim,
      filtros.eixo,
    ],
  },
  {
    title:
      getTitle()[23] ||
      "Plano de ação analítico - atualizado por município, eixo e região",
    rotaApi: "get-plano-acao",
    header: headers().plano_acao_analitico,
    category: categorias().indicador,
    id: 23,
    filters: [filtros.uf, filtros.regional, filtros.eixo],
  },

  {
    title: getTitle()[24] || "Eixos por município",
    rotaApi: "get-eixos-por-municipios",
    header: headers().eixo_municipio,
    category: categorias().indicador,
    id: 24,
    filters: [filtros.uf, filtros.regional, filtros.statusRelacionamento],
  },

  {
    title: getTitle()[25] || "Eixos por município - desagrupado",
    rotaApi: "get-eixos-por-municipios-desagrupado",
    header: headers().eixo_municipio_desagrupado,
    category: categorias().indicador,
    id: 25,
    filters: [filtros.uf, filtros.regional, filtros.statusRelacionamento],
  },
  {
    title:
      getTitle()[26] ||
      "Relação de diagnósticos e acompanhamentos realizados com Usuário e Evolução",
    rotaApi:
      "get-relacao-diagnosticos-acompanhamentos-realizados-usuario-evolucao",
    header: headers().relacao_diagnosticos,
    category: categorias().indicador,
    id: 26,
    filters: [filtros.municipio, filtros.regional, filtros.usuario],
  },
  {
    title: getTitle()[27] || "Evidências rejeitadas por município",
    rotaApi: "get-evidencia-rejeitada-por-municipio",
    header: headers().evidencia_rejeitada_por_municipio,
    category: categorias().indicador,
    id: 27,
    defaultFilters: {
      municipioId: [0],
    },
    filters: [filtros.municipio],
  },
  {
    title: getTitle()[28] || "Parceiros com respectivos selos atribuídos",
    rotaApi: "get-selo-final",
    header: headers().selo,
    category: categorias().indicador,
    id: 28,
    exibirEm: ["isSala"],

    filters: [filtros.regional, filtros.selo, filtros.municipio],
  },
  {
    title: getTitle()[29] || "Quantitativo de selos atribuídos",
    rotaApi: "quantidade-selos-atribuidos",
    header: headers().quantidade_selos_atribuidos,
    category: categorias().indicador,
    id: 29,
    defaultFilters: {
      municipioId: [0],
    },
    exibirEm: ["isSala"],
    filters: [],
  },
  {
    title: getTitle()[30] || "Diagnósticos consolidados por situação",
    rotaApi: "diagnosticos-consolidados-por-situacao",
    header: headers().diagnosticos_consolidados_situacao,
    category: categorias().indicador,
    id: 30,
    exibirEm: ["isSala"],
    filters: [],
  },
  {
    title: getTitle()[31] || "Diagnósticos detalhados",
    rotaApi: "diagnosticos-detalhados",
    headerParceiro: headersParceiro.diagnosticos_detalhados,
    header: headers().diagnosticos_detalhados,
    category: categorias().indicador,
    id: 31,
    filters: [],
    exibirEm: ["isSala"],
  },
  {
    title: getTitle()[32] || "Relatórios Administrativos por período",
    rotaApi: "get-relatorio-por-periodo",
    header: headers().diagnosticos_admin_periodo,
    category: categorias().execucao,
    id: 32,
    filters: [
      filtros.usuario,
      filtros.municipio,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[33] || "Situação detalhada do envio de evidências",
    rotaApi: "get-situacao-detalhada-envio-evidencia",
    header: headers().situacao_detalhada_envio_evidencia,
    category: categorias().indicador,
    id: 33,
    exibirEm: ["isSala"],
    filters: [filtros.municipio, filtros.regional],
  },
  {
    title: getTitle()[34] || "Analítico de Pontos por Eixo",
    rotaApi: "get-analitico-pontos-por-eixo",
    header: headers().analitico_pontos_eixos,
    category: categorias().indicador,
    id: 34,
    filters: [filtros.municipio, filtros.regional, filtros.eixo],
  },
  {
    title:
      getTitle()[35] ||
      "Quantitativo de municípios com e sem atuação por região",
    rotaApi: "get-quantidades-municipios",
    header: headers().quantitativo_municipio_sem_atuacao_regiao,
    category: categorias().indicador,
    id: 35,
    filters: [],
    exibirEm: ["isAT"],
  },
  {
    title: getTitle()[36] || "Encontros já realizados por Status",
    rotaApi: "get-encontros-realizados",
    header: headers().encontros_realizados_status,
    category: categorias().indicador,
    id: 36,
    filters: [
      filtros.regional,
      filtros.municipio,
      filtros.solucao,
      filtros.usuario,
      filtros.dataInicial,
      filtros.dataFim,
      filtros.grupoSolucao,
    ],
    exibirEm: ["isAT"],
  },
  {
    title:
      getTitle()[37] ||
      "Municípios / Territórios com status da atuação e responsável",
    rotaApi: "get-territorios-status",
    header: headers().municipios_status_atuacao_responsavel,
    category: categorias().indicador,
    id: 37,
    filters: [filtros.regional, filtros.usuario],
    exibirEm: ["isAT"],
  },
  {
    title: getTitle()[38] || "Cliente oculto analítico por situação",
    rotaApi: "get-cliente-oculto-analitico-situacao",
    header: headers().cliente_oculto_analitico_situacao,
    category: categorias().indicador,
    id: 38,
    filters: [],
    exibirEm: ["isSala"],
  },
  {
    title: getTitle()[39] || "Execução do Cliente Oculto",
    rotaApi: "get-execucao-cliente-oculto",
    header: headers().execucao_cliente_oculto,
    category: categorias().execucao,
    id: 39,
    filters: [filtros.municipio, filtros.grupoClienteOculto],
    exibirEm: ["isSala"],
  },
  {
    title: getTitle()[40] || "Mensurações detalhadas por período",
    rotaApi: "get-mensuracao-detalhe-por-perido",
    header: headers().mensuracao_detalhada_por_periodo,
    category: categorias().indicador,
    id: 40,
    onlyWithFilters: true,
    filters: [
      filtros.regional,
      filtros.municipio,
      filtros.usuario,
      filtros.dataInicial,
      filtros.dataFim,
    ],
  },
  {
    title: getTitle()[41] || "Situação das soluções nos municípios",
    rotaApi: "get-situacao-solucao-municipios",
    header: headers().situacao_solucoes_municipios,
    category: categorias().execucao,
    id: 41,
    filters: [filtros.municipio],
  },
  {
    title: getTitle()[42] || "Prateleira de soluções",
    rotaApi: "get-prateleira-solucoes",
    header: headers().prateleira_de_solucoes,
    category: categorias().execucao,
    id: 42,
    filters: [],
  },
  {
    title: getTitle()[43] || "Territórios e iniciativas",
    rotaApi: "get-territorios-iniciativas",
    header: headers().territorios_iniciativas,
    category: categorias().territorio,
    id: 43,
    filters: [],
  },
  {
    title: getTitle()[44] || "Territórios e Municípios",
    rotaApi: "get-territorios-municipios",
    header: headers().territorios_municipios,
    category: categorias().territorio,
    id: 44,
    filters: [],
  },
  // {
  //   title: getTitle()[45] || "Selo",
  //   rotaApi: "get-selo-final",
  //   header: headers().selo,
  //   category: categorias().execucao,
  //   id: 45,
  //   filters: [filtros.regional, filtros.selo, filtros.municipio],
  // },

  {
    title: getTitle()[46] || "Detalhamento das propostas",
    rotaApi: "detalhamento-proposta",
    header: headers().detalhamento_propostas,
    category: categorias().indicador,
    id: 46,
    filters: [],
  },
  {
    title: getTitle()[47] || "Status das propostas - Analítico",
    rotaApi: "status-proposta-analitico",
    header: headers().status_propostas_analitico,
    category: categorias().indicador,
    id: 47,
    filters: [],
  },
  {
    title: getTitle()[48] || "Status das propostas - Detalhado",
    rotaApi: "status-proposta-detalhada",
    header: headers().status_propostas_detalhado,
    category: categorias().indicador,
    id: 48,
    filters: [],
  },
  {
    title: getTitle()[49] || "Propostas com Valores detalhados",
    rotaApi: "proposta-rateio-receitas",
    header: headers().propostas_valores_detalhados,
    category: categorias().indicador,
    id: 49,
    filters: [],
  },
  {
    title:
      getTitle()[50] ||
      "O que falta evidenciar por município e eixo (detalhado)",
    rotaApi: "falta-evidencias-municipio-eixo-detalhado",
    header: headers().falta_evidenciar_municipio_eixo,
    category: categorias().indicador,
    id: 50,
    filters: [filtros.regional, filtros.municipio],
  },
  {
    title: getTitle()[51] || "Histórico de análise de evidências (detalhado)",
    rotaApi: "historico-analise-evidencias",
    header: headers().historico_analise_evidencia,
    category: categorias().indicador,
    id: 51,
    filters: [filtros.regional, filtros.municipio],
  },
  {
    title: getTitle()[52] || "Acompanhamento por Indicadores - Detalhado",
    rotaApi: "acompanhamento-indicadores-detalhado",
    header: headers().acompanhamento_indicador_detalhado,
    category: categorias().indicador,
    id: 52,
    filters: [],
  },

  {
    title: getTitle()[53] || "Acompanhamento por Indicadores - Consolidado",
    rotaApi: "acompanhamento-indicadores-consolidado",
    header: headers().acompanhamento_indicador_consolidado,
    category: categorias().indicador,
    id: 53,
    filters: [],
  },
  {
    title: getTitle()[54] || "Pontuação por evidências aprovadas",
    rotaApi: "obter-pontuacao-evidencia-aprovada",
    header: headers().pontuacao_evidencias_aprovadas,
    category: categorias().indicador,
    id: 54,
    filters: [filtros.regional, filtros.municipio],
  },
  {
    title: getTitle()[55] || "Nível de Maturidade",
    rotaApi: "obter-nivel-maturidade",
    header: headers().nivel_maturidade,
    category: categorias().indicador,
    id: 55,
    filters: [filtros.regional, filtros.municipio, filtros.eixo],
  },
];
